module.exports = __webpack_public_path__ + "img/Legendary Eagle Master.2646bcd5.png";